import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { ChartLogList } from '../../../../components/generic'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import DailyTotalTable from './DailyTotalTable'

class WashChart extends Component {
  constructor(props) {
    super(props)
    this.state = this.getDefaultState()
  }

  getDefaultState() {
    const { logs } = this.props
    return {
      endDate: dayjs(),
      startDate: dayjs().subtract(14, 'days').startOf('day'),
      isDefault: true,
      logs
    }
  }

  formatData = (logs) => {
    const washCountByDate = _.countBy(
      logs.map((log) => {
        return dayjs(log.timeLogged).format('DD/MM/YYYY')
      })
    )

    const formattedData = Object.keys(washCountByDate).map((key) => {
      return {
        date: key,
        value: washCountByDate[key]
      }
    })

    const washDailyTotals = [
      {
        resident: logs[0].residentId,
        data: formattedData
      }
    ]

    return washDailyTotals
  }

  setDatesAndLogs = () => {
    const { to, from, logs } = this.props
    const { startDate, endDate, isDefault } = this.state

    if (from && to && from !== startDate && to !== endDate) {
      this.setState({
        endDate: to,
        startDate: from,
        isDefault: false,
        logs
      })
    } else if (!from && !to && !isDefault) {
      this.setState(this.getDefaultState())
    }
  }

  render() {
    const { startDate, endDate, logs } = this.state
    this.setDatesAndLogs()

    return logs && logs.length ? (
      <div>
        <DailyTotalTable
          to={endDate}
          from={startDate}
          data={this.formatData(logs)}
          heatmapRanges={heatmapRanges}
          tableStyle={styles.tableStyle}
          displayResident={false}
        />
        <ChartLogList logs={logs} />
      </div>
    ) : (
      <EmptyState
        title="Shoot... No data to show you"
        description="No logs to display"
        icon={<NoDataIcon />}
      />
    )
  }
}

const heatmapRanges = {
  low: 1,
  medium: 2,
  high: 3,
  veryHigh: 4
}

const styles = {
  tableStyle: {
    minWidth: null,
    maxWidth: '75vw'
  }
}

WashChart.propTypes = {
  title: PropTypes.string.isRequired
}

export default withToolbar(WashChart, {
  pdfExport: {
    title: chartTitles.wash
  },
  timeWindow: 14,
  maximumNights: 28
})
